const messages = {
	pt: {
		translations: {
			signup: {
				title: "Criar conta",
				step1Title: "Preencha CNPJ e e-mail para começar.",
				step2Title: "Digite o código enviado ao seu e-mail.",
				step3Title: "Complete os dados da empresa e senha.",
				toasts: {
					success: "Usuário criado com sucesso! Faça seu login!!!.",
					fail: "Erro ao criar usuário. Verifique os dados informados.",
					codeSent: "Código enviado para seu e-mail.",
					emailValidated: "E-mail validado. Preencha os dados abaixo.",
				},
				form: {
					companyName: "Nome da empresa",
					companyNamePlaceholder: "Nome da sua empresa",
					cnpj: "CNPJ",
					cnpjPlaceholder: "00.000.000/0000-00",
					cnpjIncomplete: "CNPJ deve ter 14 dígitos.",
					cnpjInvalid: "CNPJ inválido. Verifique os dígitos.",
					name: "Nome completo",
					namePlaceholder: "Maria Silva",
					email: "E-mail",
					emailPlaceholder: "voce@exemplo.com",
					emailInvalid: "E-mail inválido.",
					password: "Senha",
					passwordPlaceholder: "Mínimo 8 caracteres",
					passwordHint: "Mín. 8 caracteres, 1 maiúscula e 1 especial.",
					passwordWeak: "Senha fraca: use 8+ caracteres, 1 maiúscula e 1 especial.",
					passwordStrengthWeak: "Fraca",
					passwordStrengthMedium: "Média",
					passwordStrengthStrong: "Forte",
					phone: "Celular",
					countryCode: "País",
					phonePlaceholder: "(00) 00000-0000",
					code: "Código de verificação",
					codePlaceholder: "000000",
				},
				buttons: {
					sendCode: "Enviar código",
					sendingCode: "Enviando…",
					validateEmail: "Validar e-mail",
					validatingEmail: "Validando…",
					submit: "Criar conta",
					creating: "Criando conta…",
					login: "Já tem uma conta? Entre!",
					loginPrefix: "Já tem uma conta?",
					loginLink: "Entrar",
				},
				errors: {
					codeInvalidOrExpired: "Código inválido ou expirado.",
					rateLimit: "Muitos envios. Tente novamente em 15 minutos.",
				},
			},
			login: {
				title: "Bem-vindo de volta",
				subtitle: "Entre com sua conta para continuar.",
				form: {
					email: "E-mail",
					emailPlaceholder: "voce@exemplo.com",
					password: "Senha",
					passwordPlaceholder: "••••••••",
				},
				buttons: {
					submit: "Entrar",
					register: "Não tem uma conta? Cadastre-se",
					registerPrefix: "Não tem uma conta?",
					registerLink: "Cadastre-se",
					recover: "Esqueceu a senha?",
					showPassword: "Mostrar",
					hidePassword: "Ocultar",
				},
				toggle: {
					login: "Entrar",
					signup: "Cadastrar",
				},
				hero: {
					tagline: "Todos os seus canais em um único lugar.",
					productSubtitle: "Multi Atendimento",
				},
			},
			recoverPassword: {
				title: "Esqueceu sua senha?",
				subTitle:
					"Sem problemas! Basta inserir seu e-mail e enviaremos as intruções de login.",
				form: {
					email: "E-mail",
					emailPlaceholder: "Digite seu e-mail",
					emailInvalid: "Informe um e-mail válido.",
				},
				buttons: {
					submit: "Recuperar senha",
					return: "Voltar",
				},
				toasts: {
					emailSent: "Se o e-mail estiver cadastrado, você receberá o link em instantes.",
					checkInbox: "Verifique sua caixa de entrada (e spam) e clique no link para definir uma nova senha.",
				},
			},
			resetPassword: {
				title: "Nova senha",
				subTitle: "Defina uma nova senha para sua conta.",
				form: {
					password: "Nova senha",
					passwordPlaceholder: "Digite a nova senha",
					confirmPassword: "Confirmar senha",
					confirmPasswordPlaceholder: "Repita a nova senha",
					passwordMismatch: "As senhas não coincidem.",
				},
				buttons: {
					submit: "Salvar senha",
					returnLogin: "Ir para o login",
					requestNew: "Solicitar novo link",
				},
				toasts: {
					success: "Senha alterada com sucesso! Faça login.",
				},
				errors: {
					invalidLink: "Link inválido ou expirado. Solicite uma nova recuperação de senha.",
				},
			},
			auth: {
				toasts: {
					success: "Login efetuado com sucesso!",
				},
			},
			errorFallback: {
				error: "Algo deu errado",
				instructions: "Recarregue a página ou tente novamente em alguns instantes. Se o problema continuar, entre em contato com o suporte.",
				detail: "Detalhe técnico",
			},
			dashboard: {
				epoch: {
					buttons: {
						today: "No dia",
						week: "Na semana",
						month: "No mês",
						year: "No ano",
					},
				},
				charts: {
					perDay: {
						title: "Tickets hoje: ",
					},
					attendantsChart: {
						title: "Atendimentos ativos por atendentes",
						sideTitle: "Atendimentos",
					},
					progressBar: {
						callsByDepartment: "Atendimentos por departamento",
						callsByAttendant: "Atendimentos por atendente",
						ratingsByAttendant: "Avaliações por atendente",
					},
				},
				departments: {
					title: "Departamentos",
				},
				messages: {
					inAttendance: {
						title: "Atendendo",
					},
					waiting: {
						title: "Aguardando",
					},
					closed: {
						title: "Resolvido",
					},
					connection: {
						title: "Conexões",
					},
					waitingTime: {
						title: "Tempo médio de espera",
					},
					serviceTime: {
						title: "Tempo médio de atendimento",
					},
					averageRating: {
						title: "Média de avaliação",
					},
					contacts: {
						title: "Contatos",
					},
					messages: {
						title: "Mensagens",
					},
					reviews: {
						title: "Avaliações",
					},
				},
				infoCard: {
					ticketsToday: "Quantidade de Tickets que estão sendo atendidos.",
					awaitingService: "Quantidade de Tickets aguardando atendimento.",
					ticketsSolved: "Quantidade de Tickets resolvidos.",
					connections: "Quantidade de canais conectados.",
					waitingTime:
						"Tempo médio em que os Tickets esperam para serem atendidos.",
					serviceTime:
						"Tempo médio em que os operadores realizam o atendimento.",
					averageRating: "Nota média de avaliação dos atendimentos.",
					contactNumber: "Quantidade total de Contatos.",
					messagesNumber: "Quantidade total de mensagens trocadas.",
					reviews: "Quantidade total de avaliações recebidas.",
				},
			},
			connections: {
				title: "Conexões",
				subtitle: "Gerencie canais, sessões e integrações da plataforma.",
				listTitle: "Lista de conexões",
				searchPlaceholder: "Pesquisar conexão...",
				empty: "Nenhuma conexão encontrada.",
				emptyHint: "Tente outro termo de busca.",
				toasts: {
					deleted: "Conexão com o WhatsApp excluída com sucesso!",
					webhookUpdated: "Webhook reconectado com sucesso.",
				},
				confirmationModal: {
					deleteTitle: "Deletar",
					deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
					disconnectTitle: "Desconectar",
					disconnectMessage:
						"Tem certeza? Você precisará ler o QR Code novamente.",
				},
				buttons: {
					add: "Adicionar conexão",
					edit: "Editar",
					delete: "Excluir",
					disconnect: "desconectar",
					tryAgain: "Tentar novamente",
					qrcode: "QR CODE",
					newQr: "Novo QR CODE",
					connecting: "Conectando",
					restart: "Reinicia Backend",
					reconnectWebhook: "Reconectar webhook",
				},
				toolTips: {
					disconnected: {
						title: "Falha ao iniciar sessão do WhatsApp",
						content:
							"Certifique-se de que os dados de conexão estão corretos e tente novamente",
					},
					qrcode: {
						title: "Esperando leitura do QR Code",
						content:
							"Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
					},
					connected: {
						title: "Conexão estabelecida!",
					},
					timeout: {
						title: "A conexão não é válida ou foi perdida",
						content:
							"Certifique-se de que os dados de conexão estão corretos e tente novamente.",
						contentEmail:
							"Certifique-se que seu servidor de recebimento de e-mail esteja configurado corretamente e tente novamente. Caso o problema persista, remova e recrie a conexão com dados atualizados.",
					},
				},
				table: {
					id: "ID da Instância",
					name: "Nome",
					status: "Status",
					lastUpdate: "Última atualização",
					default: "Padrão",
					battery: "Bateria",
					actions: "Ações",
					session: "Sessão",
					channel: "Canal",
				},
				marketplace: {
					configured: "Já configurado",
					configuredTitle: "Lista de canais já adicionados",
					configuredDescription: "Gerencie as conexões ativas da sua conta.",
					channelPrefix: "Canal",
					sessionStatus: {
						connected: "Conectado",
						connecting: "Conectando",
						qrcode: "Aguardando QR Code",
						disconnected: "Desconectado",
						timeout: "Sessão expirada",
						pairing: "Pareando",
					},
					createdAt: "Criado em",
					hubBadge: "Hub",
					integrationTypes: {
						native: "Nativo",
						hub: "Hub",
						seamless: "Seamless",
					},
					channelTypes: {
						instagram: "Instagram V2",
						webchat: "WebChat",
						sms: "SMS",
						mercadolivre: "Mercado Livre",
						tiktok: "TikTok",
						ifood: "iFood",
						youtube: "YouTube",
						numero_virtual: "Número Virtual",
						olx: "OLX",
						linkedin: "LinkedIn",
						magalu: "Magalu",
						gbm: "Google My Business",
						google_ads: "Google Ads",
						meta_ads: "Meta Ads",
						shein: "Shein",
						shopee: "Shopee",
					},
				},
				wizard: {
					subtitle: "Siga as etapas para configurar a nova conexão.",
					stepOf: "Etapa {{current}} de {{total}}",
					channelSelected: "Canal selecionado",
					back: "Voltar",
					next: "Próximo",
					errors: {
						nameRequired: "Informe o nome da conexão.",
					},
					stepDescriptions: {
						basic: "Dê um nome e defina se será a conexão padrão.",
						messages: "Mensagens automáticas opcionais de saudação e despedida.",
						queues: "Defina setores e comportamento do chatbot.",
						whatsappcloud: "Informe os dados da API oficial do WhatsApp Business.",
						facebook: "Informe o ID e o token de acesso da página.",
						telegram: "Informe o token do bot do Telegram.",
						email: "Configure credenciais e servidores de e-mail.",
					},
					steps: {
						basic: "Informações básicas",
						credentials: "Credenciais",
						messages: "Mensagens",
						queues: "Filas e automação",
						hubChannel: "Canal do Hub",
						hubDetails: "Detalhes da conexão",
					},
				},
				hubLinkModal: {
					title: "Vincular canal do Hub",
					subtitle:
						"Escolha o canal autorizado na sua conta NotificaMe Hub para ativar como conexão.",
					channelLabel: "Canal autorizado no Hub",
					channelPlaceholder: "Selecione o canal",
					channelHint: "Cada item mostra o tipo do canal (WhatsApp, Instagram, Facebook…) e o nome configurado no Hub.",
					channelTypeLabel: "Tipo do canal",
					selected: "Selecionado",
					submit: "Vincular conexão",
					emptyTitle: "Nenhum canal autorizado encontrado",
					emptyDescription:
						"Configure o canal no painel NotificaMe Hub e tente novamente.",
					errors: {
						channelRequired: "Selecione um canal do Hub.",
						nameRequired: "Informe o nome da conexão.",
					},
				},
				picker: {
					title: "Adicionar conexão",
					subtitle: "Escolha um canal disponível ou conecte via Seamless.",
					close: "Fechar",
					recommended: "Recomendado",
					selectChannel: "Configurar conexão",
					addChannel: "Adicionar",
					hubConnect: "Adicionar",
					hubConnectSuccess: "Canal conectado com sucesso!",
					hubConnectError: "Erro ao conectar canal.",
					hubPopupBlocked: "Popup bloqueado. Permita popups para este site.",
					hubMissingCompany: "Token do Hub não configurado. Defina em Configurações.",
					hubTokenWarning: {
						title: "Token do Hub não configurado",
						description:
							"Para vincular canais via Hub, informe o token da sua conta NotificaMe (campo Account).",
						path: "Caminho: Configurações → Integrações → Token Hub",
						link: "Configurar token do Hub",
					},
					seamlessTokenWarning: {
						title: "Integração Seamless não configurada",
						description:
							"Para adicionar canais via Seamless, informe o token da sua conta NotificaMe.",
						path: "Caminho: Configurações → Integrações → Token Hub",
						link: "Configurar token",
					},
					hubWhatsappNotEnabled: {
						help:
							"Libere o canal WhatsApp na sua conta NotificaMe (Seamless) e tente novamente. Use o token da conta (campo Account), não de um canal específico.",
					},
					sections: {
						native: {
							title: "Canais disponíveis",
							description:
								"WhatsApp nativo (QR) ou vincule canais já configurados na sua conta NotificaMe Hub.",
						},
						hub: {
							title: "Canais via Hub",
							description:
								"Vincule canais já configurados na sua conta NotificaMe Hub (WhatsApp, Facebook, Instagram, e-mail e outros).",
						},
						seamless: {
							title: "Canais via Seamless",
							description:
								"Conecte Facebook, Instagram, WhatsApp, YouTube, Google Business, LinkedIn, OLX, Mercado Livre e TikTok pela integração Seamless do NotificaMe. Clique em Adicionar para autorizar na plataforma.",
						},
					},
					channels: {
						whatsapp: {
							description: "Conecte via QR Code com sessão local.",
						},
						whatsappcloud: {
							description: "Use a API oficial do WhatsApp Business (Meta).",
						},
						email: {
							label: "E-mail",
							description: "Configure envio e recebimento por SMTP/IMAP.",
						},
						telegram: {
							description: "Conecte um bot do Telegram com token.",
						},
						facebookNative: {
							description: "Conexão manual com credenciais da página.",
						},
						instagramNative: {
							description: "Conexão manual com credenciais do perfil.",
						},
						hubIntegration: {
							label: "NotificaMe Hub",
							description:
								"Selecione um canal já autorizado na sua conta Hub para ativar na plataforma.",
						},
						hubFacebook: {
							description: "Página do Facebook conectada via OAuth Seamless.",
						},
						hubInstagram: {
							description: "Instagram Direct conectado via OAuth Seamless.",
						},
						hubWhatsapp: {
							description: "WhatsApp Business (API Meta) conectado via OAuth Seamless.",
						},
						hubYoutube: {
							description: "Comentários do canal do YouTube conectados via OAuth Seamless.",
						},
						hubGoogleBusiness: {
							description: "Perfil da empresa no Google conectado via OAuth Seamless.",
						},
						hubLinkedin: {
							description: "Página do LinkedIn conectada via OAuth Seamless.",
						},
						hubOlx: {
							description: "Chat de anúncios da OLX conectado via OAuth Seamless.",
						},
						hubMercadoLivre: {
							description: "Perguntas e mensagens do Mercado Livre conectadas via OAuth Seamless.",
						},
						hubTiktok: {
							description: "Conta do TikTok conectada via OAuth Seamless.",
						},
					},
				},
			},
			integrations: {
				title: "Integrações",
				subtitle: "Conecte serviços externos e automatize fluxos da plataforma.",
				status: {
					connected: "Conectado",
					disconnected: "Não configurado",
					comingSoon: "Em breve",
				},
				actions: {
					configure: "Configurar",
					documentation: "Documentação",
					menuAria: "Ações da integração {{name}}",
				},
				metrics: {
					status: "Status",
					category: "Categoria",
					lastSync: "Última sync",
				},
				modal: {
					title: "Configurar {{name}}",
					cancel: "Cancelar",
					save: "Salvar",
					connectGoogle: "Conectar Google",
					comingSoonToast: "Configuração disponível em breve.",
					saveSuccess: "Integração configurada com sucesso.",
					saveError: "Não foi possível salvar a configuração.",
				},
				loadError: "Não foi possível carregar as integrações.",
				asaas: {
					name: "Asaas",
					description: "Pagamentos, cobranças e Pix integrados ao atendimento.",
					category: "Pagamentos",
					modalHint:
						"Informe a API Key da sua conta Asaas para habilitar cobranças automáticas.",
					apiKeyLabel: "API Key",
					apiKeyPlaceholder: "Sua chave de API Asaas",
				},
				googleCalendar: {
					name: "Google Agenda",
					description: "Sincronize compromissos e agendamentos com o Google Calendar.",
					category: "Produtividade",
					modalHint:
						"Conecte sua conta Google para sincronizar eventos com a plataforma.",
					connectHint: "Clique em Conectar Google para autorizar o acesso à agenda.",
					connectedHint: "Conta Google vinculada a esta empresa. Você pode desconectar a qualquer momento.",
					connectSuccess: "Google Agenda conectado com sucesso.",
					connectError: "Não foi possível conectar o Google Agenda.",
					disconnect: "Desconectar",
					disconnecting: "Desconectando…",
					connecting: "Abrindo Google…",
					disconnectSuccess: "Google Agenda desconectado.",
					disconnectError: "Não foi possível desconectar o Google Agenda.",
				},
			},
			googleAgenda: {
				title: "Google Agenda",
				subtitle: "Visualize e gerencie eventos da conta Google conectada.",
				connectedAs: "Conectado como {{email}}",
				goToIntegrations: "Ir para Integrações",
				notConnectedTitle: "Google Agenda não conectado",
				notConnectedHint:
					"Conecte sua conta Google em Integrações para ver e manipular a agenda.",
				prevMonth: "Mês anterior",
				nextMonth: "Próximo mês",
				today: "Hoje",
				selectedDay: "Eventos do dia",
				noEvents: "Nenhum evento neste dia.",
				newEvent: "Novo evento",
				editEvent: "Editar evento",
				summary: "Título",
				description: "Descrição",
				contact: "Contato",
				contactSearch: "Buscar contato",
				contactSearchHint: "Digite ao menos 3 caracteres para buscar.",
				contactHint: "Opcional. Vincula este horário a um contato do sistema.",
				contactEmpty: "Nenhum contato encontrado.",
				contactClear: "Remover",
				allDay: "Dia inteiro",
				start: "Início",
				end: "Fim",
				save: "Salvar",
				cancel: "Cancelar",
				delete: "Excluir",
				deleteTitle: "Excluir evento",
				deleteConfirm: "Tem certeza que deseja excluir este evento?",
				loadError: "Não foi possível carregar os eventos.",
				saveSuccess: "Evento salvo com sucesso.",
				saveError: "Não foi possível salvar o evento.",
				deleteSuccess: "Evento excluído.",
				deleteError: "Não foi possível excluir o evento.",
				loading: "Carregando…",
				closeDayPanel: "Fechar",
				eventSingular: "evento",
				eventPlural: "eventos",
				report: "Relatório",
				settings: "Configurações",
				settingsTitle: "Configurações de agendamento",
				settingsHint:
					"Define a duração de cada horário e quantos clientes podem marcar no mesmo horário (IA e disponibilidade).",
				slotMinutes: "Duração do horário",
				slotMinutesHint: "Ex.: 60 = horários de 1 em 1 hora",
				slotCapacity: "Clientes por horário",
				slotCapacityHint: "Ex.: 2 = dois clientes no mesmo horário",
				minAdvance: "Antecedência mínima",
				minAdvanceHint:
					"O cliente não pode marcar em cima da hora — só horários com essa antecedência.",
				advanceNone: "Sem restrição",
				advance30m: "30 minutos",
				advance1h: "1 hora",
				advance2h: "2 horas",
				advance3h: "3 horas",
				advance4h: "4 horas",
				advance6h: "6 horas",
				advance12h: "12 horas",
				advance1d: "1 dia",
				advance2d: "2 dias",
				advance3d: "3 dias",
				advance7d: "7 dias",
				settingsSave: "Salvar configurações",
				settingsSaveSuccess: "Configurações salvas.",
				settingsSaveError: "Não foi possível salvar as configurações.",
				settingsLoadError: "Não foi possível carregar as configurações.",
				minutesSuffix: "min",
				notifyEnabled: "Enviar mensagem para a pessoa agendada",
				notifyHint:
					"Só envia se o horário tiver ticket, contato e telefone. A mesma mensagem vale para todos.",
				notifyWhen: "Quando enviar",
				notifyAtTime: "No horário do agendamento",
				notify30mBefore: "30 minutos antes",
				notify1hBefore: "1 hora antes",
				notify2hBefore: "2 horas antes",
				notify3hBefore: "3 horas antes",
				notify6hBefore: "6 horas antes",
				notify12hBefore: "12 horas antes",
				notify1dBefore: "1 dia antes",
				notify30mAfter: "30 minutos depois",
				notify1hAfter: "1 hora depois",
				notifyConnection: "Conexão de envio",
				notifyConnectionEmpty: "Selecione a conexão",
				notifyConnectionHint:
					"WhatsApp Business envia template. As demais conexões enviam texto.",
				notifyType: "Conteúdo",
				notifyTypeText: "Mensagem de texto",
				notifyTypeTemplate: "Template",
				notifyBody: "Mensagem",
				notifyBodyPlaceholder: "Texto enviado para todas as pessoas agendadas",
				notifyBodyRequired: "Informe a mensagem de texto.",
				notifyTemplateRequired: "Selecione um template.",
				notifyTemplateConnection: "Conexão para listar templates",
				notifyTemplateConnectionEmpty: "Selecione uma conexão WABA",
				notifyTemplateParam: "Parâmetro",
				notifyMedia: "Mídia do template",
				notifyMediaUrlPlaceholder: "URL da mídia (https://...)",
				notifyMediaRequired: "Anexe a imagem, vídeo ou documento do template.",
				notifyTemplateParamsRequired: "Preencha todos os parâmetros do template, inclusive dos botões.",
				notifyAttachMedia: "Anexar",
				notifyRemoveMedia: "Remover",
				notifyUploadingMedia: "Enviando...",
			},
			googleAgendaReport: {
				title: "Relatório de agendamentos",
				subtitle: "Planilha com todos os eventos da Google Agenda no período.",
				back: "Voltar à agenda",
				refresh: "Atualizar",
				filter: "Filtrar",
				from: "De",
				to: "Até",
				loading: "Carregando…",
				empty: "Nenhum evento no período selecionado.",
				loadError: "Não foi possível carregar o relatório.",
				notConnected: "Conecte o Google Agenda em Integrações para ver o relatório.",
				colTitle: "Título",
				colDescription: "Descrição",
				colStart: "Início",
				colEnd: "Fim",
				colTicket: "Ticket",
				colName: "Nome",
				colPhone: "Telefone",
				colChannel: "Canal",
				colReferredBy: "Indicado por",
				reminderScheduled: "Mensagem programada",
				colSource: "Quem marcou",
				colStatus: "Status",
				sourceAi: "IA",
				sourceManual: "Usuário",
				sourceSynced: "Google",
				statusFilter: "Status",
				statusAll: "Todos",
				statusScheduled: "Agendado",
				statusCompleted: "Concluído",
				statusCancelled: "Cancelado",
				statusPostponed: "Adiado",
				previewTitle: "Detalhes do agendamento",
				previewSubtitle: "Prévia da consulta e alteração de status",
				close: "Fechar",
				saveStatus: "Salvar status",
				saving: "Salvando…",
				statusSaved: "Status atualizado.",
				statusSaveError: "Não foi possível atualizar o status.",
				changeStatus: "Alterar status",
				reason: "Motivo",
				reasonOptional: "Motivo (opcional)",
				reasonPlaceholder: "Informe o motivo",
				changedBy: "Alterado por",
				openTicket: "Abrir ticket",
				searchName: "Nome",
				searchTicket: "Ticket",
				searchPhone: "Telefone",
				searchBookedBy: "Quem marcou",
				clearFilters: "Limpar filtros",
				countTotal: "Total",
				postponedBy: "Adiado por",
				newStart: "Nova data/hora de início",
				newEnd: "Nova data/hora de fim",
				postponeRequired: "Informe a nova data e o novo horário para adiar.",
				postponeInvalidRange: "O fim precisa ser depois do início.",
			},
			transactions: {
				title: "Transações",
				subtitle: "Asaas · PIX",
				loading: "Carregando transações…",
				empty: "Nenhuma transação encontrada para os filtros selecionados.",
				integrationMissing: "A integração Asaas ainda não está configurada.",
				goToIntegrations: "Configurar integração",
				summary: {
					total: "Total",
					totalHint: "Cobranças no período filtrado",
					pending: "Pendentes",
					pendingHint: "Aguardando pagamento",
					received: "Recebidas",
					receivedHint: "Pagamentos confirmados",
					receivedMonth: "Recebido no mês",
					receivedMonthHint: "Soma dos valores recebidos no mês atual",
				},
				filters: {
					search: "Buscar",
					searchPlaceholder: "Contato, telefone ou ID do pagamento…",
					period: "Período",
					periodAll: "Todos",
					periodToday: "Hoje",
					periodYesterday: "Ontem",
					period7d: "Últimos 7 dias",
					period30d: "Últimos 30 dias",
					periodMonth: "Este mês",
					status: "Status",
					statusAll: "Todos",
				},
				status: {
					pending: "Pendente",
					received: "Recebido",
				},
				columns: {
					date: "Data",
					contact: "Contato",
					amount: "Valor",
					status: "Status",
					dueDate: "Vencimento",
					paidAt: "Pago em",
					paymentId: "ID pagamento",
				},
				pagination: {
					summary: "Exibindo {{from}} a {{to}} de {{total}} transação(ões)",
					prev: "Anterior",
					next: "Próxima",
					aria: "Paginação de transações",
				},
				detail: {
					title: "Detalhe da transação",
					receivedValue: "Valor recebido",
					pixCode: "Código PIX",
					copyPix: "Copiar código PIX",
					copyPixSuccess: "Código PIX copiado.",
					copyPixError: "Não foi possível copiar o código PIX.",
					close: "Fechar",
					loadError: "Não foi possível carregar os detalhes da transação.",
				},
			},
			adminAiReports: {
				title: "Relatório IA",
				subtitle: "Análises dinâmicas da equipe com inteligência artificial",
				formTitle: "Montar relatório",
				formHint: "Defina período, filtros e focos antes de gerar a análise.",
				historyTitle: "Histórico",
				historyCount: "{{count}} relatório(s)",
				generate: "Gerar relatório",
				generating: "Gerando…",
				generatedSuccess: "Relatório gerado com sucesso.",
				refresh: "Atualizar",
				clear: "Limpar filtros",
				expand: "Ver",
				collapse: "Ocultar",
				emptyHistory: "Nenhum relatório gerado ainda.",
				emptySelection: "Selecione um relatório",
				emptySelectionHint: "Escolha um item à esquerda ou gere uma nova análise.",
				emptyQueues: "Nenhum setor encontrado.",
				emptyUsers: "Nenhum atendente encontrado.",
				allQueues: "Todos os setores",
				allUsers: "Todos os atendentes",
				selectedCount: "{{count}} selecionados",
				questionPlaceholder:
					"Ex.: quero saber quem atende melhor os clientes",
				byAuthor: "por {{name}}",
				fields: {
					scope: "Escopo do relatório",
					periodType: "Tipo de período",
					date: "Data",
					dateFrom: "De",
					dateTo: "Até",
					queues: "Setores",
					users: "Atendentes",
					ticketId: "ID do ticket",
					contact: "Contato",
					focuses: "Focos da análise",
					question: "Pergunta livre (opcional)",
				},
				scope: {
					team: "Equipe / período",
					ticket: "Ticket específico",
					contact: "Contato (últimos 3 tickets)",
				},
				scopeHint: {
					team: "Analisa a operação no período com filtros de setor e atendente.",
					ticket: "Analisa um único ticket, lendo as mensagens da conversa.",
					contact:
						"Analisa os últimos 3 tickets do contato e a evolução do lead.",
				},
				ticketPlaceholder: "Ex.: 12345",
				contactPlaceholder: "Buscar por nome ou número…",
				clearContact: "Trocar contato",
				searchingContacts: "Buscando contatos…",
				emptyContacts: "Nenhum contato encontrado.",
				messagesScopeHint:
					"Neste escopo as mensagens dos tickets são lidas automaticamente.",
				period: {
					day: "Dia",
					hour: "Intervalo por hora",
					month: "Mês",
					custom: "Personalizado",
				},
				focuses: {
					sellers: "Desempenho dos atendentes",
					talk_time: "Tempo de conversa",
					quality: "Qualidade / CSAT",
					queue_volume: "Volume por setor",
					complaints: "O que os clientes mais reclamam",
					people_improve: "Como melhorar a equipe",
					lead_interest: "Interesse do lead",
					lead_classification: "Classificação do lead",
					lead_helped: "Se o atendimento ajudou",
					messages: "Ler mensagens dos tickets",
				},
				messagesHint:
					"Inclui uma amostra das conversas na análise (mais lento e consome mais tokens).",
				messagesAutoHint:
					"Este foco já ativa a leitura de mensagens automaticamente.",
				result: {
					summary: "Resumo",
					insights: "Insights",
					ranking: "Ranking",
					recommendations: "Melhorias na equipe",
				},
				lead: {
					temperature: "Temperatura",
					score: "Score do lead",
					helped: "Atendimento ajudou?",
					classification: "Classificação",
					nextStep: "Próximo passo",
					objections: "Objeções principais",
					funnel: "Funil / alinhamento",
					tags: "Tags do contato",
					noObjections: "Nenhuma objeção clara identificada.",
					noFunnel: "Sem estágio de funil vinculado.",
					noTags: "Sem tags neste contato.",
					tempValues: {
						quente: "Quente",
						morno: "Morno",
						frio: "Frio",
						indefinido: "Indefinido",
					},
					helpedValues: {
						sim: "Sim",
						parcial: "Parcial",
						nao: "Não",
						indefinido: "Indefinido",
					},
					classificationValues: {
						boa: "Boa",
						ruim: "Ruim",
						duvidosa: "Duvidosa",
						indefinido: "Indefinido",
					},
				},
				errors: {
					needFocus: "Selecione ao menos um foco.",
					needDates: "Informe o intervalo de datas.",
					needTicket: "Informe o ID do ticket.",
					needContact: "Selecione um contato.",
				},
			},
			socialComments: {
				title: "Comentários",
				emptyList: "Nenhum comentário encontrado.",
				searchPlaceholder: "Buscar comentários…",
				loading: "Carregando comentários…",
				loadError: "Não foi possível carregar os comentários.",
				commentsCount: "{{count}} comentário(s)",
				loadMore:"Carregar mais",
				loadMoreComments: "Carregar mais comentários",
				loadingMoreComments: "Carregando comentários…",
				viewComments: "Ver comentários",
				viewOriginal: "Ver publicação original",
				emptyComments: "Nenhum comentário neste post.",

				filters: {
					channel: "Canal",
					status: "Status",
					all: "Todos",
					facebook: "Facebook",
					instagram: "Instagram",
					tiktok: "TikTok",
					mercadolivre: "Mercado Livre",
					statusAll: "Todos",
				},
				status: {
					open: "Aberto",
					replied: "Respondido",
				},
				actions: {
					reply: "Responder",
					markReplied: "Marcar respondido",
					reopen: "Reabrir",
				},
				mock: {
					banner: "Dados fictícios para demonstração — não refletem comentários reais.",
				},
				reply: {
					placeholder: "Escreva sua resposta…",
					success: "Resposta enviada (simulação local).",
				},
			},
			permissionModal: {
				title: "Ação não autorizada",
				content: "Você não tem permissão para realizar a ação.",
			},
			whatsappModal: {
				title: {
					add: "Adicionar Conexão",
					edit: "Editar Conexão",
				},
				form: {
					name: "Nome da conexão",
					default: "Padrão",
					channel: "Canal",
					farewellMessage: "Mensagem de despedida",
					whatsapp: "WhatsApp",
					facebook: "Facebook",
					telegram: "Telegram",
					instagram: "Instagram",
					whatsappcloud: "WhatsApp API",
					connectionInfo: "Informações de conexão",
					connectionInfoHint: "Datas de criação e última atualização da conexão.",
					createdAt: "Criado em",
					updatedAt: "Atualizado em",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
				success: "Conexão salva com sucesso.",
			},
			qrCode: {
				title: `Para conectar ao  ${process.env.REACT_APP_NOME}:`,
				firstPoint: "Abra o WhatsApp em seu celular.",
				secondPoint: {
					partOne: "Toque em ",
					moreOptions: "Mais opções ",
					partTwo: " ou ",
					configurations: "Configurações ",
					partThree: "e selecione Aparelhos conectados.",
				},
				thirdPoint: "Toque em Conectar um aparelho.",
				fourthPoint:
					"Aponte seu celular para esta tela para capturar o código.",
				message: "Leia o QrCode para iniciar a sessão",
				waiting: "Aguardando QR Code...",
			},
			contacts: {
				title: "Contatos",
				subtitle: "Gerenciamento",
				listTitle: "Lista de contatos",
				toasts: {
					deleted: "Contato excluído com sucesso!",
					deletedSelected: "Contatos selecionados excluídos com sucesso.",
				},
				selectAll: "Selecionar todos na lista",
				selectRow: "Selecionar {{name}}",
				selectedCount: "{{count}} selecionado(s)",
				searchPlaceholder: "Pesquisar nome, e-mail ou número...",
				filterTagsPlaceholder: "Filtrar por etiquetas",
				filterTagsSelectedCount: "{{count}} etiquetas selecionadas",
				filterTagsClear: "Limpar seleção",
				empty: "Nenhum contato encontrado.",
				emptyHint: "Tente outro termo de busca ou filtro.",
				pagination: {
					label: "Paginação",
					showing: "Exibindo {{start}}–{{end}} de {{total}}",
					previous: "Anterior",
					next: "Próxima",
				},
				confirmationModal: {
					deleteTitle: "Deletar ",
					importTitlte: "Importar contatos",
					deleteMessage:
						"Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
					deleteSelectedTitle: "Excluir contatos selecionados?",
					deleteSelectedMessage:
						"{{count}} contato(s) serão excluídos. Todos os tickets relacionados serão perdidos.",
					importMessage: "Deseja importar todos os contatos do telefone?",
				},
				buttons: {
					import: "Importar",
					export: "Exportar",
					add: "Adicionar contato",
					deleteSelected: "Excluir selecionados",
					chat: "Conversar",
					edit: "Editar",
					delete: "Excluir",
				},
				table: {
					name: "Nome",
					tags: "Etiquetas",
					whatsapp: "WhatsApp",
					email: "E-mail",
					company: "Empresa",
					actions: "Ações",
				},
			},
			contactModal: {
				title: {
					add: "Adicionar contato",
					edit: "Editar contato",
				},
				form: {
					connection: "Conexão",
					mainInfo: "Dados do contato",
					extraInfo: "Informações adicionais",
					name: "Nome",
					number: "Número do Whatsapp",
					numberHint: "DDI do país (55 para Brasil) e número com DDD (ex.: 13912344321).",
					ddi: "DDI",
					ddiRequired: "Informe o DDI (código do país, ex.: 55).",
					numberBrInvalid: "Informe DDD + número (10 ou 11 dígitos, ex.: 13912344321).",
					numberInvalid: "Número inválido para o DDI informado.",
					numberDigitsOnly: "Informe apenas números.",
					email: "Email",
					company: "Empresa",
					extraName: "Nome do campo",
					extraValue: "Valor",
				},
				buttons: {
					addExtraInfo: "Adicionar informação",
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
				success: "Contato salvo com sucesso.",
			},
			contactsImportModal: {
				title: "Importar contatos",
				success: "Contatos importados com sucesso.",
				steps: {
					upload: "Upload do arquivo",
					mapping: "Mapeamento dos campos",
					import: "Importar",
				},
				buttons: {
					cancel: "Cancelar",
					back: "Voltar",
					continue: "Continuar",
					import: "Importar",
				},
				stepOne: {
					intro: "Importe o arquivo em formato CSV com os contatos que deseja adicionar.",
					hint: "Caso seu arquivo esteja em outro formato, abra-o no Excel e exporte em formato CSV.",
					downloadSample: "Baixe um exemplo de arquivo CSV",
					filePlaceholder: "Inserir arquivo CSV",
					browse: "Procurar",
					selectedCount: "{{count}} contatos selecionados",
					warning:"Limite de contatos por CSV: 1000"
				},
				stepTwo: {
					intro: "Selecione as variáveis correspondentes aos campos do arquivo CSV.",
					name: "Nome do contato (obrigatório)",
					number: "Número do contato (obrigatório)",
					email: "E-mail do contato",
					select: "Selecione a coluna",
					none: "Nenhum",
				},
				stepThree: {
					intro: "Confirme o mapeamento dos campos com a amostra a seguir.",
				},
			},
			contactsExportModal: {
				titleExporting: "Exportando contatos",
				titleDone: "Operação concluída",
				exporting: "Aguarde enquanto o arquivo é gerado…",
				done: "Contatos exportados: {{count}}",
				close: "Fechar",
			},
			bulkMessaging: {
				title: "Envio em massa",
				subtitle: "Gerencie campanhas de mensagens em lote",
				listTitle: "Campanhas",
				empty: "Nenhuma campanha cadastrada.",
				confirmDeleteTitle: "Excluir envio em massa?",
				buttons: { add: "Adicionar envio em massa" },
				toasts: { deleted: "Envio em massa deletado!", updated: "Envio em massa atualizado!" },
				table: {
					protocol: "Protocolo",
					name: "Nome",
					sendDate: "Data de envio",
					estimatedEnd: "Término previsto",
					status: "Status",
					actions: "Ações",
				},
				status: {
					stopped: "Pausado",
					running: "Em execução",
					unstarted: "Não iniciado",
					cancelled: "Cancelado",
					complete: "Completo",
				},
				actions: {
					edit: "Editar",
					start: "Iniciar",
					pause: "Pausar",
					resume: "Continuar",
					resendAll: "Reenviar todos",
					resendAllHint: "Reenfileira apenas contatos sem confirmação de envio",
					resendFailed: "Reenviar {{count}} envios falhados",
					loading: "Carregando…",
					details: "Detalhes",
					duplicate: "Duplicar",
					delete: "Deletar",
				},
				infoModal: {
					title: "Relatório de envios",
					close: "Fechar",
					name: "Nome",
					contact: "Contato",
					status: "Status",
					attempts: "Tentativas",
					sent: "Enviada",
					notSent: "Falhou",
					pending: "Pendente",
					summarySuccess: "Sucesso",
					summaryFailed: "Falhas",
					summaryPending: "Pendentes",
					tabAll: "Todos",
					tabSuccess: "Enviados",
					tabFailed: "Falhas",
					tabPending: "Pendentes",
					errorReason: "Motivo",
					empty: "Nenhum contato neste envio.",
				},
				variablesModal: {
					title: "Variáveis de mensagem",
					hint: "Clique em uma variável para inserir na mensagem.",
					close: "Fechar",
				},
				modal: {
					titleAdd: "Criar envio de mensagem em massa",
					titleEdit: "Editar envio de mensagem em massa",
					steps: {
						campaign: "Cadastrar campanha",
						contacts: "Selecionar envios",
						review: "Revisar dados",
					},
					back: "Voltar",
					continue: "Continuar",
					finish: "Finalizar",
					reset: "Reiniciar",
					allStepsDone: "Todas as etapas foram completadas.",
				},
				wizard: {
					pageTitleAdd: "Nova campanha",
					pageTitleEdit: "Editar campanha",
					breadcrumbList: "Envio em massa",
					backToList: "Lista de campanhas",
					previousStep: "Etapa anterior",
					contactsStep: {
						intro: "Escolha como adicionar os destinatários: selecione contatos já cadastrados ou importe uma lista em CSV.",
						tabRegistered: "Contatos cadastrados",
						tabImport: "Importar lista",
						panelIncluded: "Contatos na campanha",
						panelAvailable: "Contatos disponíveis",
						selectHint: "Marque os contatos e clique em adicionar.",
						importHint: "Envie um arquivo .csv, .xlsx ou .xls com as colunas name e number (ou nome e número). Apenas números de telefone válidos serão importados.",
						downloadSample: "Baixar arquivo de exemplo",
						filePlaceholder: "Nenhum arquivo selecionado",
						browse: "Selecionar arquivo",
						addSelected: "Adicionar à campanha ({{count}})",
						selectedTitle: "Contatos da campanha ({{count}})",
						manualTitle: "Ou adicione um número avulso",
						contactName: "Nome do contato",
						contactNumber: "Número (com DDI)",
						numberExample: "Exemplo: 5527998851972",
						numberExampleShort: "5527998851972",
						numberInvalid: "Use 12 ou 13 dígitos com DDI",
						addManual: "Adicionar",
						removeSelected: "Remover selecionados ({{count}})",
						searchedCount: "Encontrados: {{count}}",
						searchPlaceholder: "Nome ou número",
						searchInputPlaceholder: "Buscar por nome ou número",
						clearSearch: "Limpar busca",
						searchTags: "Tags",
						searchButton: "Buscar",
						importEmpty: "O arquivo está vazio ou inválido.",
						importInvalidColumns: "O arquivo precisa das colunas name e number (ou nome e número).",
						importUnsupportedType: "Formato não suportado. Use .csv, .xlsx ou .xls.",
						importNoRows: "Nenhum contato válido encontrado no arquivo.",
						importSuccess: "{{count}} contato(s) importado(s) para a campanha.",
						importPartialSuccess:
							"{{valid}} contato(s) importado(s). {{invalid}} linha(s) ignorada(s) por erro.",
						importRejectedTitle: "{{count}} linha(s) não importada(s)",
						importRejectedLine: "Linha",
						importRejectedReason: "Motivo",
						importRejectReasons: {
							emptyName: "Nome vazio",
							emptyNumber: "Número vazio",
							invalidNumber: "Não é um número de telefone válido",
							duplicate: "Número duplicado no arquivo",
							alreadyInCampaign: "Já está na campanha",
						},
						importError: "Não foi possível ler o arquivo.",
						importAddedHint: "{{count}} contato(s) adicionado(s). Veja na coluna à direita.",
						emptyCampaign: "Nenhum contato na campanha ainda.",
						emptyAvailable: "Nenhum contato encontrado. Ajuste a busca ou tags.",
						loadingContacts: "Carregando contatos...",
					},
				},
			},
			quickAnswersModal: {
				title: {
					add: "Adicionar Resposta Rápida",
					edit: "Editar Resposta Rápida",
				},
				form: {
					shortcut: "Atalho",
					message: "Mensagem",
					attachImage: "Anexar imagem",
					removeImage: "Remover imagem",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
				success: "Resposta Rápida salva com sucesso.",
			},
			queueModal: {
				title: {
					add: "Adicionar Setor",
					edit: "Editar Setor",
				},
				notification: {
					title: "Setor salvo com sucesso!",
					chatbotAdded: "Chatbot vinculado ao setor com sucesso!",
					saveBeforeChatbot: "Salve o setor para vincular o chatbot.",
				},
				form: {
					name: "Nome",
					color: "Cor",
					greetingMessage: "Mensagem de saudação",
					startWork: "Abertura",
					endWork: "Fechamento",
					absenceMessage: "Mensagem de ausência",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
			},
			userModal: {
				title: {
					add: "Adicionar usuário",
					edit: "Editar usuário",
				},
				form: {
					name: "Nome",
					email: "E-mail",
					password: "Senha",
					profile: "Perfil",
					admin: "Administrador",
					whatsapp: "Conexão Padrão",
					user: "Usuário",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
				success: "Usuário salvo com sucesso.",
			},
			chat: {
				noTicketMessage: "Selecione um ticket para começar a conversar.",
				noChatDescription:
					"Envie e receba mensagens sem precisar manter seu celular conectado à internet",
				noChatDescriptionText:
					`Use o  ${process.env.REACT_APP_NOME} em quantos computadores quiser e um celular ao mesmo tempo.`,
				layout: {
					tryNewExperience: "Usar nova experiência",
					newExperienceBadge: "Novo",
					newExperienceActive: "Nova experiência ativa",
					backToClassicShort: "Voltar",
					backToClassic: "Voltar ao layout clássico",
					classicLayoutRailLabel: "Layout clássico",
					toggleHint:
						"Alterna só o visual do chat. A lista da empresa (legado/nova) continua definida em Configurações.",
					switched: "Layout do chat atualizado.",
					chatsTitle: "Conversas",
					openSection: "Tickets abertos",
					backToList: "Conversas",
					selectConversationHint: "Selecione uma conversa na lista ao lado.",
					searchPlaceholder: "Pesquisar ou começar uma conversa",
					newConversation: "Nova conversa",
					recentChats: "Conversas recentes",
					allConversations: "Todas as conversas",
					pendingSection: "Tickets pendentes",
					closedSection: "Fechadas",
					statusSection: "Status",
					filters: "Filtros",
					filterAll: "Tudo",
					filterChannel: "Canais",
					filterChannelEmpty: "Nenhum canal foi encontrado.",
					selectFilterChannel: "Selecionar canais",
					filterUnread: "Não lidas",
					filterUnreadWithCount: "Não lidas, {{count}} mensagens não lidas",
					filterGroups: "Grupos",
					filterSort: "Ordenação",
					filterSortAsc: "Mais antigos primeiro",
					filterSortDesc: "Mais recentes primeiro",
					filterQueues: "Setores",
					filterTags: "Etiquetas",
					filterQueuesEmpty: "Nenhum setor disponível",
					filterTagsEmpty: "Nenhuma etiqueta disponível",
					filterTagsSearch: "Buscar etiquetas...",
					filterTagsPlaceholder: "Selecionar etiquetas",
					filterTagsNoResults: "Nenhuma etiqueta encontrada",
					filterClearAll: "Limpar",
					filterApply: "Aplicar",
					salesFunnel: "Funil de vendas",
					loadMore: "Carregar mais",
					loadingMore: "Carregando...",
				},
			},
			ticketsManager: {
				buttons: {
					newTicket: "Novo",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Setores",
			},
			tickets: {
				toasts: {
					deleted: "O ticket que você estava foi deletado.",
				},
				notification: {
					message: "Mensagem de",
				},
				tabs: {
					open: { title: "Inbox" },
					closed: { title: "Resolvidos" },
					search: { title: "Busca" },
				},
				search: {
					placeholder: "Buscar tickets e mensagens",
					recentTitle: "Recentes",
					recentClear: "Limpar tudo",
					recentRemove: "Remover pesquisa",
				},
				buttons: {
					showAll: "Todos",
				},
			},
			templateOnlyBar: {
				message:
					"Fora da janela de 24 horas da Meta. Envie um template para continuar a conversa.",
			},
			transferTicketModal: {
				title: "Transferir Ticket",
				fieldLabel: "Digite para buscar usuários",
				fieldQueueLabel: "Transferir para o Setor",
				fieldConnectionLabel: "Transferir para conexão",
				fieldQueuePlaceholder: "Transferir para o Setor",
				fieldConnectionPlaceholder: "Selecione uma conexão",
				noOptions: "Nenhum usuário encontrado com esse nome",
				buttons: {
					ok: "Transferir",
					cancel: "Cancelar",
				},
			},
			statusList: {
				title: "Status do WhatsApp",
				subtitle: "Toque em um contato para ver a atualização de status.",
				viewStatus: "Ver status",
				published: "Status publicado",
				unavailable: "Mídia do status indisponível",
				emptyTitle: "Nenhum status no momento",
				emptyMessage:
					"Quando contatos publicarem status, eles aparecerão aqui. Ative “Status do perfil” em Configurações.",
			},
			ticketsList: {
				pendingHeader: "Aguardando",
				assignedHeader: "Atendendo",
				noTicketsTitle: "Nada aqui!",
				noTicketsMessage:
					"Nenhum ticket encontrado com esse status ou termo pesquisado",
				connectionTitle: "Conexão que está sendo utilizada atualmente.",
				items: {
					queueless: "Sem Setor",
					accept: "Aceitar",
					spy: "Espiar",
					close: "Encerrar",
					reopen: "Reabrir",
				},
				buttons: {
					accept: "Responder",
					acceptBeforeBot: "Aceitar",
					start: "iniciar",
					cancel: "Cancelar",
				},
				acceptModal: {
					title: "Aceitar Chat",
					queue: "Selecionar setor",
				},
			},
			newTicketModal: {
				title: "Criar Ticket",
				fieldLabel: "Digite para pesquisar o contato",
				add: "Adicionar",
				buttons: {
					ok: "Salvar",
					cancel: "Cancelar",
				},
			},
			master: {
				layout: {
					title: "Painel Master",
					subtitle: "Administração do sistema",
					toggleMenu: "Alternar menu",
					closeMenu: "Fechar menu",
					toggleTheme: "Alternar tema",
					searchPlaceholder: "Buscar...",
					ModalIa:"gerenciador IA"
				},
				nav: {
					dashboard: "Dashboard",
					companies: "Empresas",
					plans: "Planos",
					addons: "Compras avulsas",
					coupons: "Cupons",
					finance: "Financeiro",
					system: "Análise do servidor",
					documents: "Informativos",
					searchUsers: "Usuários por empresa",
					scheduleLogs: "Logs de agendamentos",
					bulkMessagingLogs: "Logs envio em massa",
					sectionOverview: "Geral",
					sectionCommercial: "Comercial",
					sectionSystem: "Sistema",
					sectionLogs: "Logs",
				},
				documents: {
					pageTitle: "Informativos",
					pageSubtitle: "Avisos, Meta, atualizações e eventos para as empresas",
				},
				plans: {
					pageTitle: "Planos",
					pageSubtitle: "Catálogo de planos do sistema",
					listTitle: "Planos cadastrados",
					countLabel: "registros",
					loading: "Carregando planos...",
					empty: "Nenhum plano cadastrado",
					emptyHint: "Crie o primeiro plano para disponibilizar no catálogo.",
					create: "Novo plano",
					createTitle: "Novo plano",
					editTitle: "Editar plano",
					edit: "Editar",
					delete: "Excluir",
					close: "Fechar",
					cancel: "Cancelar",
					save: "Salvar",
					saving: "Salvando...",
					fieldName: "Nome",
					fieldPriceMonthly: "Preço mensal",
					fieldPriceQuarterly: "Preço trimestral",
					fieldPriceSemiannual: "Preço semestral",
					fieldPriceAnnual: "Preço anual",
					fieldMonthlyTokens: "Tokens mensais",
					fieldActive: "Ativo no catálogo",
					pricesHint: "Defina o preço de cada ciclo de cobrança no mesmo plano.",
					colName: "Nome",
					colPriceMonthly: "Mensal",
					colPriceQuarterly: "Trimestral",
					colPriceSemiannual: "Semestral",
					colPriceAnnual: "Anual",
					colMonthlyTokens: "Tokens/mês",
					tokensShort: "tokens/mês",
					perMonth: "por mês",
					statTotal: "Total de planos",
					statActive: "Planos ativos",
					statInactive: "Planos inativos",
					colStatus: "Status",
					colActions: "Ações",
					confirmDelete: "Remover o plano \"{{name}}\"?",
					confirmDeleteMessage: "Se o plano estiver vinculado a empresas, ele será apenas desativado.",
					toastCreated: "Plano criado.",
					toastUpdated: "Plano atualizado.",
					toastDeleted: "Plano removido.",
					toastDisabled: "Plano desativado (há empresas vinculadas).",
				},
				addons: {
					pageTitle: "Compras avulsas",
					pageSubtitle: "Pacotes adicionais do catálogo (tokens e outros itens)",
					listTitle: "Pacotes cadastrados",
					countLabel: "registros",
					loading: "Carregando pacotes...",
					empty: "Nenhum pacote cadastrado",
					emptyHint: "Crie o primeiro pacote de tokens adicionais.",
					create: "Novo pacote",
					createTitle: "Novo pacote",
					editTitle: "Editar pacote",
					edit: "Editar",
					delete: "Excluir",
					cancel: "Cancelar",
					save: "Salvar",
					saving: "Salvando...",
					fieldName: "Nome",
					fieldQuantity: "Quantidade de tokens",
					fieldPrice: "Preço",
					fieldActive: "Ativo no catálogo",
					formHint: "Pacote de tokens adicionais sem expiração.",
					typeTokens: "Tokens",
					tokensUnit: "tokens",
					statTotal: "Total de pacotes",
					statActive: "Pacotes ativos",
					statInactive: "Pacotes inativos",
					confirmDelete: "Remover o pacote \"{{name}}\"?",
					confirmDeleteMessage: "Se o pacote estiver vinculado a compras, ele será apenas desativado.",
					toastCreated: "Pacote criado.",
					toastUpdated: "Pacote atualizado.",
					toastDeleted: "Pacote removido.",
					toastDisabled: "Pacote desativado (há compras vinculadas).",
				},
				coupons: {
					pageTitle: "Cupons",
					pageSubtitle: "Cupons de desconto para compras e assinaturas",
					listTitle: "Cupons cadastrados",
					countLabel: "registros",
					loading: "Carregando cupons...",
					empty: "Nenhum cupom cadastrado",
					emptyHint: "Crie o primeiro cupom de desconto.",
					create: "Novo cupom",
					createTitle: "Novo cupom",
					editTitle: "Editar cupom",
					edit: "Editar",
					delete: "Excluir",
					cancel: "Cancelar",
					save: "Salvar",
					saving: "Salvando...",
					fieldName: "Código",
					fieldDiscountType: "Tipo de desconto",
					fieldDiscountValue: "Valor do desconto",
					fieldExpiresAt: "Validade",
					fieldLifetime: "Vitalício (sem validade)",
					fieldEmailRef: "E-mail restrito",
					fieldActive: "Ativo no catálogo",
					formHint: "Código único. Deixe o e-mail vazio para uso geral.",
					emailHint: "Opcional. Se preenchido, o cupom vale só para este e-mail.",
					typePercentage: "Porcentagem",
					typeFixed: "Valor fixo",
					noExpiry: "Vitalício",
					anyEmail: "Qualquer e-mail",
					statTotal: "Total de cupons",
					statActive: "Cupons ativos",
					statInactive: "Cupons inativos",
					confirmDelete: "Remover o cupom \"{{name}}\"?",
					confirmDeleteMessage: "Se o cupom estiver vinculado a planos, ele será apenas desativado.",
					toastCreated: "Cupom criado.",
					toastUpdated: "Cupom atualizado.",
					toastDeleted: "Cupom removido.",
					toastDisabled: "Cupom desativado (há planos vinculados).",
				},
				finance: {
					pageTitle: "Financeiro",
					pageSubtitle: "Compras, assinaturas e uso de cupons",
					periodPreset: "Período",
					period30: "Últimos 30 dias",
					period90: "Últimos 90 dias",
					periodMonth: "Mês atual",
					periodAll: "Todo o período",
					periodCustom: "Personalizado",
					from: "De",
					to: "Até",
					kpiRevenuePaid: "Receita paga (tokens)",
					kpiRevenuePending: "Pendente (tokens)",
					kpiSubsActive: "Assinaturas ativas",
					kpiSubsWithCoupon: "Assinaturas com cupom",
					revenueChart: "Receita paga por mês",
					noChartData: "Sem dados de receita no período.",
					purchasesByStatus: "Resumo",
					statusPaid: "Pago",
					statusPending: "Pendente",
					statusCanceled: "Cancelado",
					statusActive: "Ativo",
					statusExpired: "Expirado",
					statusInactive: "Inativo",
					subsCanceled: "Assinaturas canceladas",
					subsExpired: "Assinaturas expiradas",
					tab: {
						purchases: "Compras avulsas",
						subscriptions: "Assinaturas",
						coupons: "Cupons",
					},
					allStatuses: "Todos os status",
					allCoupons: "Todas as assinaturas",
					onlyWithCoupon: "Somente com cupom",
					emptyPurchases: "Nenhuma compra encontrada.",
					emptySubscriptions: "Nenhuma assinatura encontrada.",
					emptyCoupons: "Nenhum uso de cupom encontrado.",
					colCompany: "Empresa",
					colAddon: "Pacote",
					colTotal: "Total",
					colDiscount: "Desconto",
					colStatus: "Status",
					colPaymentId: "Payment ID",
					colDate: "Data",
					colPlan: "Plano",
					colTokens: "Tokens usados",
					colCoupon: "Cupom",
					colStarted: "Início",
					colExpires: "Expira",
					colUsage: "Usos",
					colLastUsed: "Último uso",
					records: "registros",
					prev: "Anterior",
					next: "Próxima",
				},
				scheduleLogs: {
					pageTitle: "Logs de agendamentos",
					pageSubtitle: "Erros e avisos do envio agendado (Go/Redis)",
					trackPageTitle: "Trilha do agendamento",
					trackBreadcrumb: "Trilha",
					listTitle: "Registros de erro e aviso",
					records: "registros",
					allCompanies: "Todas as empresas",
					filterScheduleId: "ID do agendamento",
					allLevels: "Todos os níveis",
					levelError: "Erro",
					levelWarn: "Aviso",
					allEvents: "Todos os eventos",
					searchMessage: "Buscar na mensagem...",
					empty: "Nenhum log encontrado com os filtros atuais.",
					colDate: "Data/hora",
					colSchedule: "Agendamento",
					colCompany: "Empresa",
					colEvent: "Evento",
					colLevel: "Nível",
					colMessage: "Mensagem",
					colStatus: "Status",
					colActions: "Ações",
					viewTrack: "Ver trilha",
					showing: "Exibindo {{start}}–{{end}} de {{total}}",
					prev: "Anterior",
					next: "Próxima",
					trackTitle: "Trilha de execução",
					scheduleId: "Agendamento",
					close: "Fechar",
					sendAt: "Enviar em",
					contactId: "Contato",
					lastError: "Último erro",
					noLogsForSchedule: "Nenhum log registrado para este agendamento.",
					traceTitle: "Passos até a falha",
					channel: "Canal",
				},
				bulkMessagingLogs: {
					pageTitle: "Logs de envio em massa",
					pageSubtitle: "Erros e avisos do envio em massa (Go/Asynq)",
					trackPageTitle: "Trilha da campanha",
					trackBreadcrumb: "Trilha",
					listTitle: "Registros de erro e aviso",
					records: "registros",
					allCompanies: "Todas as empresas",
					filterBulkId: "ID da campanha",
					filterContactNumber: "Número do contato",
					allLevels: "Todos os níveis",
					levelError: "Erro",
					levelWarn: "Aviso",
					allEvents: "Todos os eventos",
					searchMessage: "Buscar na mensagem...",
					empty: "Nenhum log encontrado com os filtros atuais.",
					colDate: "Data/hora",
					colBulk: "Campanha",
					colNumber: "Número",
					colCompany: "Empresa",
					colEvent: "Evento",
					colLevel: "Nível",
					colMessage: "Mensagem",
					colStatus: "Status",
					colName: "Nome",
					colActions: "Ações",
					viewTrack: "Ver trilha",
					showing: "Exibindo {{start}}–{{end}} de {{total}}",
					prev: "Anterior",
					next: "Próxima",
					trackTitle: "Trilha de execução",
					bulkId: "Campanha",
					close: "Fechar",
					protocol: "Protocolo",
					contactNumber: "Número",
					lastError: "Último erro",
					noLogsForBulk: "Nenhum log registrado para esta campanha.",
					traceTitle: "Passos até a falha",
					channel: "Canal",
					statsSuccess: "Enviados",
					statsFailed: "Falhas",
					statsPending: "Pendentes",
				},
				system: {
					cpu: "Processador (CPU)",
					ram: "Memória (RAM)",
					storage: "Armazenamento",
					uptime: "Tempo ativo",
					free: "Livre",
					usage: "Uso",
					cores: "núcleos",
					volumes: "Volumes de disco",
					volumeCount: "volumes",
					mount: "Montagem",
					fs: "Sistema de arquivos",
					capacity: "Capacidade",
					loading: "Carregando métricas do servidor...",
					loadError: "Falha ao carregar informações do sistema.",
					retry: "Tentar novamente",
					refreshing: "Atualizando",
				},
				dashboard: {
					totalCompanies: "Total de empresas",
					activeCompanies: "Empresas ativas",
					totalUsers: "Total de usuários",
					totalConnections: "Total de conexões",
					active: "Ativas",
					inactive: "Inativas",
					registrationsChart: "Cadastros por mês",
					statusChart: "Status das empresas",
					topCompaniesChart: "Top empresas por usuários",
					noChartData: "Sem dados para exibir",
					systemCardTitle: "Saúde do servidor",
					systemCardLink: "Ver análise completa",
					memory: "Memória",
					disk: "Disco",
				},
				pages: {
					dashboardTitle: "Dashboard",
					dashboardSubtitle: "Visão geral do sistema e métricas das empresas",
					companiesTitle: "Empresas",
					statusActive: "Ativo",
					statusInactive: "Inativo",
					editCompany: "Editar",
					companiesListTitle: "Empresas cadastradas",
					companiesListSubtitle: "Todas as empresas do sistema",
					companiesCountLabel: "registros",
					companiesSearchPlaceholder: "Buscar por nome, documento ou ID",
					companiesFilterAll: "Todos os status",
					companiesShowing: "Exibindo {{start}}–{{end}} de {{total}} resultados",
					colCompany: "Empresa",
					colUsers: "Usuários",
					colLimit: "Limite",
					colConnections: "Conexões",
					colContractDueDate: "Vencimento",
					colContractValue: "Valor",
					colContractDetails: "Detalhes do contrato",
					colStatus: "Status",
					colCreated: "Cadastro",
					colActions: "Ações",
					activate: "Ativar",
					deactivate: "Inativar",
					masterCompanyLocked: "A empresa Master do sistema não pode ser inativada.",
					masterCompanyBadge: "Sistema",
					systemTitle: "Análise do sistema",
					systemSubtitle: "CPU, memória e armazenamento do servidor · atualização automática a cada 30s",
					systemLastUpdate: "Última atualização",
					systemRefresh: "Atualizar agora",
					searchUsersTitle: "Usuários por empresa",
					searchUsersSubtitle: "Selecione uma empresa para listar os usuários",
					searchUsersCompanyLabel: "Empresa",
					searchUsersSelectCompany: "Selecione uma empresa",
					searchUsersSearchLabel: "Buscar",
					searchUsersPlaceholder: "Nome, e-mail ou ID...",
					searchUsersListTitle: "Usuários da empresa",
					searchUsersCountLabel: "registros",
					searchUsersStatTotal: "Usuários encontrados",
					searchUsersNoCompany: "Nenhuma empresa selecionada",
					searchUsersNoCompanyHint: "Escolha uma empresa no campo acima para ver os usuários.",
					searchUsersLoading: "Carregando usuários...",
					searchUsersEmpty: "Nenhum usuário encontrado",
					searchUsersEmptyHint: "Tente outro termo de busca.",
					searchUsersShowing: "Exibindo {{start}}–{{end}} de {{total}}",
					colUser: "Usuário",
					colEmail: "E-mail",
					colProfile: "Perfil",
					companyOwner: "Responsável",
					profile_user: "Atendente",
					profile_admin: "Administrador",
					profile_master: "Master",
					editCompanyTitle: "Editar empresa",
					contractSectionTitle: "Contrato",
					contractSectionHint: "Observações comerciais e data de vencimento preenchidas manualmente.",
					contractDetailsLabel: "Detalhes do contrato",
					contractDetailsHint: "Registre o que foi acordado com o cliente (plano, condições, observações).",
					contractDetailsPlaceholder: "Ex.: Plano anual com 5 usuários e suporte prioritário...",
					contractDueDateLabel: "Data de vencimento",
					contractDueDateHint: "Data em que o contrato ou licença vence.",
					contractValueLabel: "Valor do contrato",
					contractValueHint: "Valor acordado com o cliente (informativo, preenchimento manual).",
					contractValuePlaceholder: "Ex.: 1500.00",
					viewContractDetails: "Ver detalhes do contrato",
					contractDetailsReadOnlyLabel: "Observações do contrato",
					noContractDetails: "Nenhum detalhe cadastrado para esta empresa.",
					loading: "Carregando...",
					loadingCompany: "Carregando dados da empresa...",
					saving: "Salvando...",
					passwordOptional: "Deixe em branco para não alterar a senha.",
					loadingCompanies: "Carregando empresas...",
					noCompanies: "Nenhuma empresa cadastrada",
					noCompaniesHint: "As empresas aparecerão aqui quando forem criadas.",
					viewCompany: "Visualizar empresa",
					viewCompanySubtitle: "Dados e contato",
					viewPlanNameLabel: "Plano",
					close: "Fechar",
					previous: "Anterior",
					next: "Próxima",
					pageOf: "Página {{page}} de {{total}}",
					companiesRange: "{{start}}–{{end}} de {{total}} empresas",
				},
				editCompany: {
					planSectionTitle: "Plano / tokens",
					planSectionHint:
						"Defina o plano do catálogo ou um plano personalizado e a cota mensal de tokens. O valor cobrado fica em Valor do contrato. O botão Salvar da empresa também grava o plano.",
					planModeLabel: "Modo",
					planModeCatalog: "Catálogo",
					planModeCustom: "Personalizado",
					planCatalogLabel: "Plano do catálogo",
					planCatalogPlaceholder: "Selecione um plano",
					planCustomNameLabel: "Nome do plano",
					planCustomNamePlaceholder: "Ex.: Plano corporativo custom",
					planMonthlyTokensLabel: "Cota mensal de tokens",
					planMonthlyTokensHint: "Pode sobrescrever a cota padrão do plano do catálogo.",
					planExpiresAtLabel: "Validade do plano",
					planExpiresAtHint: "Opcional. Deixe em branco se não houver expiração.",
					planStatusLabel: "Status",
					planStatusActive: "Ativo",
					planStatusCanceled: "Cancelado",
					planStatusExpired: "Expirado",
					planUsedTokens: "Tokens usados",
					planExtraTokens: "Tokens extras",
					planRemainingTokens: "Tokens restantes",
					planNoActive: "Nenhum plano ativo. Salve para criar.",
					planSave: "Salvar plano",
					planSaving: "Salvando plano...",
					planSaved: "Plano atualizado com sucesso.",
					planLoadError: "Não foi possível carregar os planos do catálogo.",
					planCustomNameRequired: "Informe o nome do plano personalizado (mín. 2 caracteres).",
					companyAndPlanSaved: "Empresa e plano atualizados com sucesso.",
				},
			},
			mainDrawer: {
				listItems: {
					dashboard: "Dashboard",
					connections: "Conexões",
					tickets: "Conversas",
					socialComments: "Comentários",
					contacts: "Contatos",
					quickAnswers: "Respostas Rápidas",
					documentation: "Informativos",
					bulkMessaging: "Envio em massa",
					queues: "Setores",
					tags: "Etiquetas",
					schedules: "Agendamentos",
					googleAgenda: "Google Agenda",
					administration: "Administração",
					followUp: "Follow-up",
					users: "Usuários",
					settings: "Configurações",
					sendMsg: "Envio de Mensagens",
					sendMedia: "Envio de Mídia",
					api: "Uso da API",
					apidocs: "Documentação",
					apititle: "API",
					apikey: "API Key",
					token: "Token",
					salesFunnel: "Funil de vendas",
				},
				appBar: {
					site: {
						title: ` ${process.env.REACT_APP_NOME}`,
					},
					user: {
						profile: "Configurações do Perfil",
						logout: "Sair",
					},
				},
			},
			notifications: {
				noTickets: "Nenhuma notificação.",
			},
			layout: {
				topbarSearch: {
					placeholder: "Buscar páginas, contatos e conversas...",
					pages: "Páginas",
					contacts: "Contatos",
					tickets: "Conversas",
					noResults: "Nenhum resultado encontrado.",
					loading: "Buscando...",
					systemVersion: "Versão do sistema",
				},
			},

			followUp: {
				title: "Follow-up",
				adminSubtitle: "Administração",
				listTitle: "Regras por setor",
				listHint: "Se a última mensagem for sua (atendente) e o cliente não responder, o sistema envia o texto e depois aplica a ação.",
				loading: "Carregando setores…",
				empty: "Nenhum setor encontrado.",
				enabled: "Ativo",
				disabled: "Inativo",
				modalTitle: "Configurar follow-up",
				modalHint: "O follow-up começa depois que você envia uma mensagem. A ação só roda se o cliente não responder no segundo prazo.",
				summary: {
					active: "Setores com follow-up",
					activeHint: "Regras ativas neste momento.",
					how: "Como funciona",
					howHint: "1) Você envia uma mensagem. 2) Se o cliente não responder em X horas, envia o follow-up. 3) Se ainda não responder, aplica a ação.",
				},
				table: {
					queue: "Setor",
					status: "Status",
					delays: "Prazos (msg / ação)",
					action: "Ação",
					actions: "Ações",
				},
				fields: {
					enabled: "Ativar follow-up neste setor",
					body: "Mensagem",
					bodyPlaceholder: "Oi, ainda está aí? Posso te ajudar com mais alguma coisa?",
					messageHours: "Horas até a mensagem",
					actionHours: "Horas até a ação após a mensagem",
					action: "Ação se não responder",
					targetQueue: "Setor destino",
					targetUser: "Usuário destino",
					none: "Nenhum",
					closeMode: "Ao fechar o ticket",
					closeSilent: "Fechar sem enviar mensagem",
					closeSilentHint: "O ticket é resolvido e o cliente não recebe nada além do follow-up já enviado.",
					closeFarewell: "Fechar com despedida e avaliação",
					closeFarewellHint: "Envia a mensagem de despedida da conexão e o link de avaliação do atendimento.",
					tags: "Tags após a ação",
					tagsHint: "Opcional. Aplicadas no ticket/contato se o cliente não responder e a ação rodar. Deixe vazio para não marcar nada.",
					tagsEmpty: "Nenhuma tag cadastrada.",
				},
				actionPending: "Mover para pendente",
				actionClose: "Fechar ticket",
				actionChangeQueue: "Mudar de setor",
				actionTransferUser: "Transferir para um usuário",
				buttons: {
					configure: "Configurar",
					save: "Salvar",
					saving: "Salvando…",
					cancel: "Cancelar",
				},
				toasts: {
					saved: "Follow-up salvo.",
				},
				errors: {
					bodyRequired: "Informe a mensagem para ativar o follow-up.",
					queueRequired: "Escolha o setor destino.",
					userRequired: "Escolha o usuário destino.",
				},
			},

			queues: {
				title: "Setores",
				notifications: {
					queueDeleted: "Setor excluído com sucesso.",
				},
				table: {
					name: "Nome",
					color: "Cor",
					greeting: "Mensagem de saudação",
					actions: "Ações",
					startWork: "Abertura",
					endWork: "Fechamento",
				},
				buttons: {
					add: "Adicionar setor",
				},
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteMessage:
						"Tem certeza? Esta ação não pode ser desfeita. Os tickets deste setor continuarão existindo, mas não terão mais nenhum setor atribuído.",
				},
			},
			queueSelect: {
				inputLabel: "Setores",
			},
			autoQueueSelect: {
				inputLabel: "Chatbot: Seleção automática de setor",
				empty: "Nenhum setor selecionado",
			},
			chatbotMaxAttempts: "Chatbot: Máximo de tentativas",
			quickAnswers: {
				title: "Respostas Rápidas",
				subtitle: "Atalhos de mensagem para usar nas conversas",
				listTitle: "Lista de respostas",
				empty: "Nenhuma resposta rápida encontrada.",
				emptyHint: "Tente outro termo de busca.",
				pagination: {
					label: "Paginação",
					showing: "Exibindo {{start}}–{{end}} de {{total}}",
					previous: "Anterior",
					next: "Próxima",
				},
				selectAll: "Selecionar todas na lista",
				selectRow: "Selecionar {{shortcut}}",
				selectedCount: "{{count}} selecionada(s)",
				table: {
					shortcut: "Atalho",
					message: "Mensagem",
					file: "Arquivo",
					hasFile: "Sim",
					actions: "Ações",
				},
				buttons: {
					add: "Adicionar resposta",
					deleteSelected: "Excluir selecionadas",
					edit: "Editar",
					delete: "Excluir",
				},
				toasts: {
					deleted: "Resposta Rápida excluída com sucesso.",
					deletedSelected: "Respostas selecionadas excluídas com sucesso.",
				},
				searchPlaceholder: "Pesquisar...",
				confirmationModal: {
					deleteTitle:
						"Tem certeza de que deseja excluir esta resposta rápida: ",
					deleteMessage: "Esta ação não pode ser revertida.",
					deleteSelectedTitle: "Excluir respostas selecionadas?",
					deleteSelectedMessage:
						"{{count}} resposta(s) serão excluídas. Esta ação não pode ser revertida.",
				},
			},
			users: {
				title: "Usuários",
				table: {
					name: "Nome",
					email: "E-mail",
					profile: "Perfil",
					whatsapp: "Conexão padrão",
					actions: "Ações",
				},
				buttons: {
					add: "Adicionar usuário",
				},
				toasts: {
					deleted: "Usuário excluído com sucesso.",
				},
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteMessage:
						"Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a espera.",
				},
			},
			templates: {
				title: "Templates",
				table: {
					type: "Tipo",
					status: "Status",
					name: "Nome",
					email: "E-mail",
					category: "Categoria",
					profile: "Perfil",
					whatsapp: "Conexão padrão",
					actions: "Ações",
					header: "Cabeçalho",
					body: "Corpo",
					footer: "Rodapé",
					statuses: {
						APPROVED: "Aprovado",
						PENDING: "Pendente",
						REJECTED: "Rejeitado",
					},
					types: {
						UTILITY: "Utilidade",
						MARKETING: "Marketing",
						AUTHENTICATION: "Autenticação",
					},
				},
				buttons: {
					add: "Adicionar template",
				},
				toasts: {
					deleted: "Template excluído com sucesso.",
				},
				templateModal: {
					title: {
						create: "Adicionar template",
						update: "Editar template",
					},
					connection: "Conexão",
					name: "Nome",
					header: "Cabeçalho",
					body: "Corpo",
					footer: "Rodapé",
					buttons: {
						create: "Criar",
						update: "Atualizar",
						cancel: "Cancelar",
					},
				},
				confirmationModal: {
					deleteTitle: "Excluir",
					deleteMessage: "Todas as informações do template serão perdidas.",
				},
			},
			schedules: {
				title: "Agendamentos",
				subtitle: "Organize mensagens programadas e acompanhe o status dos envios",
				listTitle: "Lista de agendamentos",
				searchPlaceholder: "Pesquisar agendamento...",
				empty: "Nenhum agendamento encontrado.",
				emptyHint: "Tente outro termo de busca.",
				templateLabel: "Template: {{id}}",
				pagination: {
					label: "Paginação",
					showing: "Exibindo {{start}}–{{end}} de {{total}}",
					previous: "Anterior",
					next: "Próxima",
				},
				confirmationModal: {
					deleteTitle: "Tem certeza de que deseja excluir este agendamento?",
					deleteMessage: "Esta ação não pode ser revertida.",
				},
				table: {
					contact: "Contato",
					body: "Mensagem",
					sendAt: "Data de Agendamento",
					sentAt: "Data de Envio",
					status: "Status",
					actions: "Ações",
				},
				buttons: {
					add: "Novo Agendamento",
					edit: "Editar",
					delete: "Excluir",
				},
				toasts: {
					deleted: "Agendamento excluído com sucesso.",
				},
			},
			scheduleModal: {
				title: {
					add: "Novo Agendamento",
					edit: "Editar Agendamento",
				},
				subtitle: "Configure conexão, contato, conteúdo e data de envio.",
				form: {
					connection: "Conexão de origem",
					connectionHint: "Selecione a conexão antes de buscar um contato.",
					body: "Mensagem",
					contact: "Contato",
					searchContact: "Buscar contato",
					searchContactHint: "Digite ao menos 3 caracteres para buscar.",
					contactSearchEmpty: "Nenhum contato encontrado.",
					sendAt: "Data de Agendamento",
					sentAt: "Data de Envio",
					media: "Arquivo",
					attachFile: "Anexar arquivo",
					removeFile: "Remover arquivo",
					mediaHint: "Mídias aceitas: jpg, jpeg, png, mp4 e pdf.",
					messageHint: "Para inserir variáveis na mensagem, digite \"$\".",
					templateSection: "Template aprovado",
					templateSectionHint: "Selecione um template aprovado para o envio.",
					templateParams: "Parâmetros do template",
					paramText: "Texto livre",
					paramContactName: "Nome do contato",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
				variablesTitle: "Variáveis de mensagem",
				statusLabel: "Status",
				contactRequired:
					"Selecione um contato nos resultados da busca antes de salvar.",
				success: "Agendamento salvo com sucesso.",
			},
			tags: {
				title: "Etiquetas",
				subtitle: "Administração",
				listTitle: "Lista de etiquetas",
				countLabel: "registros",
				searchPlaceholder: "Pesquisar etiqueta...",
				empty: "Nenhuma etiqueta encontrada.",
				emptyHint: "Tente outro termo de busca.",
				pagination: {
					label: "Paginação",
					showing: "Exibindo {{start}}–{{end}} de {{total}}",
					previous: "Anterior",
					next: "Próxima",
				},
				selectAll: "Selecionar todas na lista",
				selectRow: "Selecionar {{name}}",
				selectedCount: "{{count}} selecionada(s)",
				confirmationModal: {
					deleteTitle: "Você tem certeza que quer excluir esta etiqueta?",
					deleteMessage: "Esta ação não pode ser revertida.",
					deleteSelectedTitle: "Excluir etiquetas selecionadas?",
					deleteSelectedMessage:
						"{{count}} etiqueta(s) serão excluídas. Esta ação não pode ser revertida.",
				},
				table: {
					id: "ID",
					name: "Nome",
					color: "Cor",
					tickets: "Registros Etiquetados",
					actions: "Ações",
					contacts: "Contatos",
					absentTag: "Tag ausente",
					absentTagYes: "Sim",
				},
				buttons: {
					add: "Adicionar etiqueta",
					deleteSelected: "Excluir selecionadas",
					edit: "Editar",
					delete: "Excluir",
				},
				toasts: {
					deleted: "Etiqueta excluída com sucesso.",
					deletedSelected: "Etiquetas selecionadas excluídas com sucesso.",
				},
			},
			settings: {
				success: "Configurações salvas com sucesso.",
				title: "Configurações",
				apiKey: {
					regenerate: "Regenerar API Key",
					regenerateConfirm: "Gerar uma nova API Key? A anterior deixará de funcionar. Copie a nova chave após confirmar.",
					regenerateSuccess: "Nova API Key gerada. Copie e guarde em local seguro.",
					regenerateWarning: "Ao regenerar, a chave anterior deixa de funcionar. Use a nova chave nas integrações.",
				},
				settings: {
					userCreation: {
						name: "Criação de usuário",
						options: {
							enabled: "Ativado",
							disabled: "Desativado",
						},
					},
					CheckMsgIsGroup: {
						name: "Ignorar mensagens de grupos",
						options: {
							enabled: "Ativado",
							disabled: "Desativado",
						},
					},
					call: {
						name: "Aceitar chamadas",
						note: "Se desabilitado, o cliente receberá uma mensagem informando que chamadas de voz e vídeo não são aceitas.",
						options: {
							enabled: "Ativado",
							disabled: "Desativado",
						},
					},
					sideMenu: {
						name: "Menu lateral inicial",
						note: "Se habilitado, o menu lateral iniciará fechado.",
						options: {
							enabled: "Aberto",
							disabled: "Fechado",
						},
					},
					closeTicketApi: {
						name: "Encerrar ticket enviado pela API",
						note: "Fecha automaticamente o ticket quando ele é enviado pela API.",
						options: {
							enabled: "Ativado",
							disabled: "Desativado",
						},
					},
					darkMode: {
						name: "Ativar modo escuro",
						note: "Alterna entre os modos claro e escuro.",
						options: {
							enabled: "Ativado",
							disabled: "Desativado",
						},
					},
					businessTimezone: {
						name: "Fuso horário",
						note: "Define o fuso usado para exibir datas, horários e filtros do sistema.",
						options: {
							zone_serverDefault: "Padrão do sistema"
						}
					},
					timeCreateNewTicket: {
						name: "Criar novo ticket após",
						note: "Selecione após quanto tempo um novo ticket será aberto caso o cliente entre em contato novamente.",
						options: {
							10: "10 Segundos",
							30: "30 Segundos",
							60: "1 minuto",
							300: "5 minutos",
							1800: "30 minutos",
							3600: "1 hora",
							7200: "2 horas",
							21600: "6 horas",
							43200: "12 horas",
							86400: "24 horas",
							604800: "7 dias",
							1296000: "15 dias",
							2592000: "30 dias",
						},
					},
					sortBy: {
						nameOpen: "Ordenar tickets abertos por",
						namePending: "Ordenar tickets pendentes por",
						nameClosed: "Ordenar tickets fechados por",
						note: "Selecione a ordem em que deseja visualizar os tickets.",
						options: {
							asc: "Mais antigos",
							desc: "Mais recentes"
						}
					}
				},
			},
			messagesList: {
				header: {
					assignedTo: "Responsável:",
					buttons: {
						return: "Retornar",
						resolve: "Resolver",
						reopen: "Reabrir",
						accept: "Aceitar",
						solverWithoutGoodbye: "Resolver sem despedida",
					},
				},
			},

			// press ''/'' to use the registered quick responses
			messagesInput: {
				placeholderOpen:
					"Digite uma mensagem ou insira ''/'' para ver as respostas rápidas.",
				placeholderClosed:
					"Reabra ou aceite esse ticket para enviar uma mensagem.",
				signMessage: "Assinar",
				stickerPicker: {
					title: "Figurinhas",
					mine: "Minhas",
					company: "Empresa",
					upload: "Nova",
					send: "Enviar figurinha",
					loading: "Carregando...",
					emptyMine: "Nenhuma figurinha salva. Salve uma na conversa.",
					emptyCompany: "Nenhuma figurinha da empresa ainda.",
					invalidEmpty: "Figurinha inválida ou vazia.",
					invalidSize:
						"A figurinha deve ter no máximo 512 KB (512000 bytes).",
					invalidMime:
						"Formato inválido. Use image/webp (ou application/octet-stream). PNG/JPEG não são aceitos.",
					remove: "Remover figurinha",
					deleted: "Figurinha removida",
					deletedCompany: "Figurinha removida do pack da empresa",
					deleteCompanyForbidden:
						"Apenas admin pode remover figurinhas da empresa",
					emojiTab: "Emojis",
				},
				micPermissionDeniedTitle: "Microfone bloqueado",
				micPermissionDenied:
					"Permita o acesso ao microfone para gravar áudio neste atendimento.",
				micPermissionDeniedHint:
					"No navegador, clique no cadeado ao lado da URL e defina Microfone como Permitir. Depois recarregue a página.",
				micNotFoundTitle: "Microfone não encontrado",
				micNotFound:
					"Nenhum microfone foi detectado neste dispositivo.",
				micInUseTitle: "Microfone em uso",
				micInUse:
					"O microfone está sendo usado por outro aplicativo. Feche-o e tente novamente.",
				micInsecureTitle: "Conexão não segura",
				micInsecure:
					"A gravação de áudio exige HTTPS ou acesso via localhost.",
				micUnknownTitle: "Erro ao acessar o microfone",
				micUnknown:
					"Não foi possível iniciar a gravação. Verifique as permissões do navegador e tente novamente.",
				dismissMicAlert: "Entendi",
				composerTabsLabel: "Modo de envio",
				composerTabReply: "Responder",
				composerTabPrivate: "Mensagem Privada",
				composerTabAiReport: "Relatório IA",
				privateMessagePlaceholder: "Digite uma anotação",
				privateMessageAlertTitle: "Mensagem privada",
				privateMessageTimelineBadge: "Só equipe",
				privateMessageAlert:
					"Esta anotação é visível apenas para sua equipe. O cliente não recebe nem visualiza este conteúdo.",
				privateMessageAlertHint:
					"Use este modo para registrar observações internas, lembretes ou informações sensíveis do atendimento.",
				privateMessageHistoryTitle: "Histórico de mensagens privadas",
				privateMessageHistoryHint:
					"Anotações internas deste contato (podem incluir outros tickets). O cliente não vê.",
				privateMessageHistoryEmpty:
					"Nenhuma mensagem privada para este atendimento ainda.",
				privateMessageTicketRef: "Ticket #{{id}}",
				privateMessageUnknownAuthor: "Atendente",
				dismissPrivateMessageAlert: "Entendi",
				aiReport: {
					panelTitle: "Relatório IA",
					panelHint:
						"A IA analisa a conversa deste ticket e gera um resumo com problemas, tom emocional e conclusão. O cliente não vê este conteúdo.",
					generate: "Gerar relatório",
					generating: "Gerando relatório...",
					generatedSuccess: "Relatório gerado com sucesso",
					emptyTitle: "Nenhum relatório ainda",
					emptyHint:
						"Clique em Gerar relatório para analisar a conversa deste atendimento.",
					ticketBadge: "Ticket #{{id}}",
					currentTicket: "Ticket atual",
					summary: "Resumo",
					problems: "Problemas",
					noProblems: "Nenhum problema específico identificado.",
					emotion: "Tom emocional",
					emotionUnknown: "indefinido",
					conclusion: "Conclusão",
					generatedBy: "Gerado por {{name}}",
				},
			},
			contactDrawer: {
				header: "Dados do contato",
				buttons: {
					edit: "Editar contato",
				},
				extraInfo: "Outras informações",
				bookings: {
					title: "Horários marcados",
					empty: "Nenhum horário marcado para este contato.",
					disconnected: "Google Agenda não conectada.",
					add: "Adicionar horário",
					loading: "Carregando…",
					save: "Salvar",
					cancel: "Cancelar",
					titleLabel: "Título",
					descriptionLabel: "Descrição",
					startLabel: "Início",
					endLabel: "Fim",
					saveSuccess: "Horário agendado com sucesso.",
					saveError: "Não foi possível agendar.",
					loadError: "Não foi possível carregar os horários.",
					sourceAi: "IA",
					sourceManual: "Usuário",
					statusScheduled: "Agendado",
					statusCompleted: "Concluído",
					statusCancelled: "Cancelado",
					statusPostponed: "Adiado",
					changedBy: "Alterado por",
					reason: "Motivo",
					changeStatus: "Status",
					reasonOptional: "Motivo (opcional)",
					statusSaved: "Status atualizado.",
					statusSaveError: "Não foi possível atualizar o status.",
					seeAll: "Ver todos os agendamentos",
					postponedBy: "Adiado por",
					newStart: "Nova data/hora de início",
					newEnd: "Nova data/hora de fim",
					postponeRequired: "Informe a nova data e o novo horário para adiar.",
					postponeInvalidRange: "O fim precisa ser depois do início.",
					channelLabel: "Canal",
					channelUnknown: "Não foi informado de onde ele veio",
					channelReferral: "Indicação",
					channelSite: "Site",
					channelOther: "Outro",
					channelOtherLabel: "Qual canal?",
					channelOtherPlaceholder: "Ex.: TikTok, rádio, panfleto…",
					referredByLabel: "Quem indicou",
					referredByPlaceholder: "Nome de quem indicou",
					reminderScheduled: "Mensagem programada",
				},
			},
			searchDrawer: {
				header: "Buscar mensagem",
				searchLabel: "Pesquisar",
				yesterday: "ontem",
				locale: "ptBR",
			},
			ticketOptionsMenu: {
				delete: "Deletar",
				transfer: "Transferir",
				confirmationModal: {
					title: "Deletar o ticket #",
					titleFrom: "do contato ",
					message:
						"Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
				},
				confirmationbukuModal: {
					title: "Deletar os tickets selecionados",
					message: "Atenção! Todas as mensagens relacionadas aos tickets serão perdidas.",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Cancelar",
				},
			},
			messageOptionsMenu: {
				delete: "Deletar",
				edit: "Editar",
				edited: "Editada",
				editEmpty: "Digite o novo texto da mensagem",
				editSuccess: "Mensagem editada",
				reply: "Responder",
				downloadAudio: "Baixar áudio",
				saveSticker: "Salvar figurinha",
				saveStickerCompany: "Salvar figurinha da empresa",
				stickerSaved: "Figurinha salva",
				stickerAlreadySaved: "Figurinha já estava salva",
				editModal: {
					title: "Editar mensagem",
					confirm: "Salvar",
				},
				confirmationModal: {
					title: "Apagar mensagem?",
					message: "Esta ação não pode ser revertida.",
				},
			},
			languages: {
				undefined: "Idioma",
				"pt-BR": "Português",
				es: "Español",
				en: "English",
			},
			tagModal: {
				title: {
					add: "Criar Etiqueta",
					edit: "Editar Etiqueta",
				},
				form: {
					name: "Nome",
					color: "Cor",
					pickColor: "Escolher cor",
					absentTag: "Etiqueta ausente",
				},
				buttons: {
					okAdd: "Adicionar",
					okEdit: "Salvar",
					cancel: "Cancelar",
				},
				success: "Etiqueta salva com sucesso.",
			},
			backendErrors: {
				TICKET_NOT_FOUND: "Ticket não encontrado.",
				ERR_INVALID_NUMBER_LENGTH: "Número muito longo (máximo 15 dígitos com DDI).",
				ERR_INVALID_BR_NUMBER: "Número brasileiro inválido: use 55 + DDD + número.",
				BULK_HAS_NO_CONTACTS_TO_SEND:
					"Não há contatos novos (verifique o reenvio em caso de falhas).",
				ERR_TAG_NAME_ALREADY_EXISTS: "Já existe uma tag com esse nome.",
				ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
				ERR_NO_DEF_WAPP_FOUND:
					"Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
				ERR_WAPP_NOT_INITIALIZED:
					"Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
				ERR_WAPP_CHECK_CONTACT:
					"Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
				ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
				ERR_WAPP_BULK_INVALID_CONTACT: "Todos os contatos não são números de Whatsapp válidos ou há um problema com a conexão.",
				ERR_WAPP_DOWNLOAD_MEDIA:
					"Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
				ERR_INVALID_CREDENTIALS:
					"Erro de autenticação. Por favor, tente novamente.",
				ERR_SENDING_WAPP_MSG:
					"Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
				ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
				ERR_OTHER_OPEN_TICKET: "Já existe um ticket aberto para este contato.",
				ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
				ERR_USER_CREATION_DISABLED:
					"A criação do usuário foi desabilitada pelo administrador.",
				ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
				ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
				ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
				ERR_COMPANY_NOT_FOUND_FOR_USER:
					"Não foi possível identificar a empresa do usuário para esta operação.",
				ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
				ERR_NO_TICKET_FOUND: "Nenhum ticket encontrado com este ID.",
				ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
				ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
				ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
				ERR_CREATING_TICKET: "Erro ao criar ticket no banco de dados.",
				ERR_FETCH_WAPP_MSG:
					"Erro ao buscar a mensagem no WhatsApp, talvez ela seja muito antiga.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS:
					"Esta cor já está em uso, escolha outra.",
				ERR_WAPP_GREETING_REQUIRED:
					"A mensagem de saudação é obrigatório quando há mais de um Setor.",
				ERR_CNPJ_INVALID: "CNPJ inválido.",
				ERR_CNPJ_ALREADY_REGISTERED: "Este CNPJ já está cadastrado.",
				ERR_INVALID_EMAIL: "E-mail inválido.",
				ERR_SIGNUP_RATE_LIMIT: "Muitos envios. Tente novamente em 15 minutos.",
				ERR_EMAIL_SEND_FAILED: "Não foi possível enviar o e-mail. Tente mais tarde.",
				ERR_INVALID_RESET_TOKEN: "Link inválido ou expirado. Solicite uma nova recuperação de senha.",
				ERR_INVALID_CODE: "Código inválido.",
				ERR_INVALID_OR_EXPIRED_CODE: "Código inválido ou expirado.",
				ERR_VERIFICATION_TOKEN_REQUIRED: "Token de verificação é obrigatório.",
				ERR_VERIFICATION_TOKEN_INVALID: "Token de verificação inválido ou expirado.",
				ERR_VERIFICATION_TOKEN_MISMATCH: "Dados não conferem com a verificação.",
				ERR_VERIFICATION_TOKEN_ALREADY_USED: "Este link de verificação já foi utilizado.",
				ERR_PASSWORD_MIN_LENGTH: "A senha deve ter no mínimo 8 caracteres.",
				ERR_PASSWORD_UPPERCASE: "A senha deve ter pelo menos uma letra maiúscula.",
				ERR_PASSWORD_SPECIAL: "A senha deve ter pelo menos um caractere especial.",
				ERR_USER_CREATION_COUNT:
					"Limite de usuários atingido para esta empresa. Cada empresa tem direito a 2 usuários além do administrador.",
				ERR_CANNOT_REMOVE_COMPANY_OWNER:
					"O administrador da empresa não pode ser removido.",
				ERR_CONNECTION_CREATION_COUNT:
					"Limite de conexões atingido, para alterar entre em contato com o suporte.",
			},
		},
	},
};

export { messages };
